import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { translate } from '../../Services/translation';
import {
  submitDiscountCode,
  deleteDiscountCode,
  setDiscountCode,
  submitError,
} from '../../Actions/Checkout.action';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import Chip from '../Chip';
import Input from '../Inputs/Input';
import clsx from 'clsx';

const Discount = () => {
  const dispatch = useDispatch();
  const { payload, errors = {} } = useTypedSelector(
    (state) => state.checkout
  );
  const { usedDiscountCodes } = payload;
  const [inputDiscountCode, setInputDiscountCode] = useState('');
  const [showDiscountInput, setShowDiscountInput] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (errors && !errors['discountCode']?.length) {
      setInputDiscountCode('');
    }
  }, [errors]);

  const submitDiscount = async (code) => {
    setIsLoading(true);
    await dispatch(setDiscountCode(code));
    await dispatch(submitDiscountCode());
    setIsLoading(false);
  };

  const onChange = (code) => {
    setInputDiscountCode(code);
    if (errors['discountCode']?.length > 0 && !code.length) {
      dispatch(
        submitError({
          modelState: {
            discountCode: [],
          },
        })
      );
    }
  };

  return (
    <div className="mb-4">
      <a
        className="cursor-pointer py-2"
        onClick={() => setShowDiscountInput(!showDiscountInput)}
      >
        <span className="border-b border-gray-700 text-md font-normal uppercase tracking-[0.5px]">
          {translate('checkout.usecampaigncode')}
        </span>
      </a>
      {showDiscountInput && (
        <div className="mb-4 mt-4 flex gap-3">
          <div className="relative flex flex-1">
            <Input
              type="text"
              id="checkout__discount"
              inputSize="large"
              className="flex-1 border border-solid border-gray-300 p-3"
              onBlur={() => !inputDiscountCode}
              value={inputDiscountCode}
              onKeyDown={(e) =>
                e.key == 'Enter' && submitDiscount(inputDiscountCode)
              }
              placeholder={translate('checkout.fillcampaigncode')}
              onChange={(e) => onChange(e.target.value)}
              disabled={isLoading}
              message={
                errors['discountCode']?.length > 0
                  ? errors['discountCode'][0]
                  : null
              }
              inputState={
                errors['discountCode']?.length > 0 ? 'error' : 'default'
              }
            />
            <label
              className="absolute -top-2 left-[14px] bg-white px-1 text-sm leading-normal"
              htmlFor="checkout__discount"
            >
              {translate('checkout.campaigncode')}
            </label>
          </div>
          <button
            className="btn btn--outline btn--large min-w-1/4 h-[unset] self-auto border-gray-700"
            onClick={() => submitDiscount(inputDiscountCode)}
            disabled={!inputDiscountCode || isLoading}
          >
            {translate('general.use')}
          </button>
        </div>
      )}
      {usedDiscountCodes && (
        <div className="mt-4 flex gap-2">
          {usedDiscountCodes.map((code) => (
            <Chip
              key={'used-discount-code-' + code}
              onDeleteClick={() => dispatch(deleteDiscountCode(code))}
            >
              {code}
            </Chip>
          ))}
        </div>
      )}
    </div>
  );
};

export default Discount;
